
import Header from "../components/header";
import Project from "../components/project";

export default function content({ modalHandler }) {
  return (
    <div className="flex flex-col pt-8 mt-8 text-2xl text-white leading-loose border bc-foreground w-full">

      <div className="mx-8">
        <Header
          text={ "Projects"}>
        </Header>
      </div>
      
      <div className="flex flex-row flex-wrap mt-4 mb-6 px-4">
      
        <Project 
          name="upwn"
          title="Upwn"
          desc="Infinite sidescrolling Godot game for Windows."
          images={ [
            "/pngs/upwn-game.png",
            "/pngs/upwn-custom.png",
            "/pngs/upwn-menu.png",
            "/pngs/upwn-splash.png"
          ] }
          modalHandler={ modalHandler }>
        </Project>

        <Project 
          name="idwal"
          title="Idwal"
          desc="Flutter application for Idwal shipping inspections."
          images={ [
            "/pngs/idwal-comms.png",
            "/pngs/idwal-survey.png",
            "/pngs/idwal-home.png",
            "/pngs/idwal-icon.png"
          ] }
          modalHandler={ modalHandler }>
        </Project>

        <Project 
          name="unicalc"
          title="UniCalc"
          desc=".Net Windows application for predicting university grades."
          images={ [
            "/pngs/unicalc-results.png",
            "/pngs/unicalc-assessments.png",
            "/pngs/unicalc-modules.png",
            "/pngs/unicalc-icon.png"
          ] }
          modalHandler={ modalHandler }>
        </Project>

        <Project 
          name="robot.ai"
          title="Robot.AI"
          desc="Godot simulation where robots compete to survive."
          images={ [
            "/pngs/robot-example2.png",
            "/pngs/robot-example1.png",
            "/pngs/robot-home.png",
            "/pngs/robot-icon.png"
          ] }
          modalHandler={ modalHandler }>
        </Project>

        <Project 
          name="activito"
          title="Activito"
          desc="Flutter application for history logging."
          images={ [
            "/pngs/activito-records.png",
            "/pngs/activito-type.png",
            "/pngs/activito-landing.png",
            "/pngs/activito-icon.png"
          ] }
          modalHandler={ modalHandler }>
        </Project>

      </div>

    </div>
  )
}